<template>
  <div>
    <el-form :model="form" ref="form" label-width="70px" :inline="false" size="small">
      <el-form-item label="标题" prop="title" :rules="rules">
        <el-input v-model.trim="form.title" placeholder="请粘贴小红书内容的标题"></el-input>
      </el-form-item>
      <el-form-item label="封面图" prop="image" :rules="rules">
        <el-input v-model.trim="form.image" placeholder="请粘贴小红书的封面图片地址"></el-input>
      </el-form-item>
      <el-form-item label="URL" prop="url" :rules="rules">
        <el-input v-model.trim="form.url" placeholder="请粘贴该条小红书的链接地址"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSubmit('form')">立即添加</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  data () {
    return {
      form: {
        title: '',
        image: '',
        url: ''
      },
      rules: { required: true, message: '必填项，不能为空', trigger: 'blur' }
    }
  },
  methods: {
    onSubmit (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.handleCreate(formName)
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    handleCreate (formName) {
      const that = this
      that.axios.post('admin/note', that.form).then(function (resp) {
        if (resp.data.code === 0) {
          that.$message.success('添加成功')
          that.$refs[formName].resetFields()
          that.$emit('success')
        }
        if (resp.data.code === 1) {
          that.$message.error(resp.data.msg)
        }
      })
    }
  }
}
</script>

<style scoped>

</style>
